<div class="links-container">
    <a href="https://www.linkedin.com/company/nexo-global-management-sl/mycompany/"><i class="bi bi-linkedin "></i></a>
    <a href="https://instagram.com/golfmobile2020?igshid=1uqedx0ymemin"><i class="bi bi-instagram"></i></a>
    <a href="https://www.facebook.com/nexotelecom.es"><i class="bi bi-facebook"></i></a>
</div>